module.exports = __webpack_public_path__ + "images/feature/20171110-1-f8bf5a159608f0b381224b9a6d4b8943.png";